import adamURL from '@cointracker/assets/general/testimonials/adam.png?url';
import aresAndroURL from '@cointracker/assets/general/testimonials/ares-andro.png?url';
import chandanIconURL from '@cointracker/assets/general/testimonials/employee/chandan.png?url';
import ishitaIconURL from '@cointracker/assets/general/testimonials/employee/ishita.png?url';
import jacobIconURL from '@cointracker/assets/general/testimonials/employee/jacob.png?url';
import jonIconURL from '@cointracker/assets/general/testimonials/employee/jon.png?url';
import judeIconURL from '@cointracker/assets/general/testimonials/employee/jude.png?url';
import sarahIconURL from '@cointracker/assets/general/testimonials/employee/sarah.png?url';
import sonaliIconURL from '@cointracker/assets/general/testimonials/employee/sonali.png?url';
import homeBrewURL from '@cointracker/assets/general/testimonials/homebrew.png?url';
import joshuaCrawfordURL from '@cointracker/assets/general/testimonials/joshua-crawford.png?url';
import joshuaURL from '@cointracker/assets/general/testimonials/joshua.png?url';
import nftLive4MeURL from '@cointracker/assets/general/testimonials/nft-live-4-me.png?url';
import scottieBURL from '@cointracker/assets/general/testimonials/scottie-b.png?url';
import tomURL from '@cointracker/assets/general/testimonials/tom.png?url';
import trade3zzURL from '@cointracker/assets/general/testimonials/trade3zz.png?url';
import type { SocialTestimonial } from '@cointracker/styleguide';
import cointrackerLogoUrl from '@cointracker/styleguide/src/icons/social/cointracker.svg?url';
import xIconURL from '@cointracker/styleguide/src/icons/social/x-monochrome.svg?url';

export const JOSHUA_R_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'Joshua R',
  date: 'January 22, 2024',
  body: "I've used @CoinTracker since 2021. I can not express enough how useful it is to have auto-tracking on all your wallets. Gotta stay compliant, so thank you for an incredible product and all the literature that you guys provide!",
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: joshuaURL,
};

export const ADAM_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'Adam',
  date: 'January 22, 2024',
  body: 'TLDR use @CoinTracker. I spent hundreds of hours with other software.',
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: adamURL,
};

export const SCOTTIE_B_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'Scottie B',
  date: 'April 14, 2024',
  body: '@Cointracker Made Taxes a breeze compared to all the manual entry needed. Quick and easy!',
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: scottieBURL,
};

export const ARES_ANDRO_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'Ares Andro',
  date: 'April 15, 2024',
  body: '@CoinTracker Just had my crypto tax done with @Cointracker! smooth operator!',
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: aresAndroURL,
};

export const TOM_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'Tom',
  date: 'April 15, 2024',
  body: 'I have been using ZenLedger for the past 2 years but CoinTracker has seriously upped their game\n\n\nBest crypto tax calculator experience by a mile!',
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: tomURL,
};

export const JOSHUA_CRAWFORD_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'Joshua Crawford',
  date: 'April 14, 2024',
  body: "@CoinTracker makes crypto axes so much easier to complete! Thanks y'all!",
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: joshuaCrawfordURL,
};

export const TRADE3ZZ_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'trad3zz',
  date: 'September 7, 2024',
  body: 'Looks like this year i will be using @CoinTracker for my taxes. Thank you for seamlessly integrating all my onchain transactions. ',
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: trade3zzURL,
};

export const NFTLIVE_4_ME_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'NFT Live 4 Me',
  date: 'April 14, 2024',
  body: `These people are freaking awesome. They've been incredibly helpful answering all of my #cryptotax questions! Just in time for #taxseason #taxsavings. Thanks @CoinTracker!!!`,
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: nftLive4MeURL,
};

export const HOMEBREW_SOCIAL_TESTIMONIAL: SocialTestimonial = {
  name: 'Homebrew',
  date: 'January 17, 2024',
  body: `The @CoinTracker team has remarkable customer focus and the latest product release speaks exactly to that mindset...`,
  socialIconSrc: xIconURL,
  socialIconAlt: 'X',
  profileSrc: homeBrewURL,
};

export const LANDING_SOCIAL_TESTIMONIALS: SocialTestimonial[] = [
  NFTLIVE_4_ME_SOCIAL_TESTIMONIAL,
  TOM_SOCIAL_TESTIMONIAL,
  ADAM_SOCIAL_TESTIMONIAL,
  JOSHUA_R_SOCIAL_TESTIMONIAL,
  SCOTTIE_B_SOCIAL_TESTIMONIAL,
  ARES_ANDRO_SOCIAL_TESTIMONIAL,
  JOSHUA_CRAWFORD_SOCIAL_TESTIMONIAL,
  TRADE3ZZ_SOCIAL_TESTIMONIAL,
  HOMEBREW_SOCIAL_TESTIMONIAL,
];

export const JON_EMPLOYEE_TESTIMONIAL: SocialTestimonial = {
  name: 'Jon Lerner',
  date: 'Co-Founder',
  body: "We believe widespread adoption of crypto will drastically increase peoples' quality of life. We are motivated to build the critical products that enable everyone in the world to use crypto with peace of mind.",
  profileSrc: jonIconURL,
  socialIconAlt: 'CoinTracker',
  socialIconSrc: cointrackerLogoUrl,
};

export const CHANDAN_EMPLOYEE_TESTIMONIAL: SocialTestimonial = {
  name: 'Chandan Lodha',
  date: 'Co-Founder',
  body: "I have ambition for CoinTracker to be the place where people do their lives' best work. Big mission, lofty challenges, free rein. Join us in changing the course of financial history.",
  profileSrc: chandanIconURL,
  socialIconAlt: 'CoinTracker',
  socialIconSrc: cointrackerLogoUrl,
};

export const SARAH_EMPLOYEE_TESTIMONIAL: SocialTestimonial = {
  name: 'Sarah Rosenzweig',
  date: 'Customer Experience',
  body: 'Working for a company with a customer-first mindset is truly empowering. It ensures that every decision, large or small, is driven by our core mission: to provide peace of mind to all crypto users.',
  profileSrc: sarahIconURL,
  socialIconAlt: 'CoinTracker',
  socialIconSrc: cointrackerLogoUrl,
};

export const ISHITA_EMPLOYEE_TESTIMONIAL: SocialTestimonial = {
  name: 'Ishita Shah',
  date: 'Engineering',
  body: 'CoinTracker is a great place to work for engineers, where every team member has a voice, ownership of impactful projects, and the opportunity to shape the future of an exciting and rapidly evolving industry.',
  profileSrc: ishitaIconURL,
  socialIconAlt: 'CoinTracker',
  socialIconSrc: cointrackerLogoUrl,
};

export const JUDE_EMPLOYEE_TESTIMONIAL: SocialTestimonial = {
  name: 'Jude Sue',
  date: 'Design',
  body: "CoinTracker offers an excellent environment for designers eager to tackle complex user experience challenges in the emerging crypto space. It's a place to learn and refine your craft alongside a talented, supportive design team and cross-functional peers.",
  profileSrc: judeIconURL,
  socialIconAlt: 'CoinTracker',
  socialIconSrc: cointrackerLogoUrl,
};

export const JACOB_EMPLOYEE_TESTIMONIAL: SocialTestimonial = {
  name: 'Jacob Wong',
  date: 'Chief of Staff',
  body: 'What I love most about CoinTracker is that it has the two ingredients to change the world: a team of sharp, accountability-first individuals and a mission that will make the world a better place.',
  profileSrc: jacobIconURL,
  socialIconAlt: 'CoinTracker',
  socialIconSrc: cointrackerLogoUrl,
};

export const SONALI_EMPLOYEE_TESTIMONIAL: SocialTestimonial = {
  name: 'Sonali Moholkar',
  date: 'Engineering',
  body: "CoinTracker unites innovation and collaboration. Engineers tackle wallets, exchanges, and blockchain challenges, building scalable crypto solutions and shaping web3's future.",
  profileSrc: sonaliIconURL,
  socialIconAlt: 'CoinTracker',
  socialIconSrc: cointrackerLogoUrl,
};

export const EMPLOYEE_TESTIMONIALS: SocialTestimonial[] = [
  JON_EMPLOYEE_TESTIMONIAL,
  CHANDAN_EMPLOYEE_TESTIMONIAL,
  SARAH_EMPLOYEE_TESTIMONIAL,
  ISHITA_EMPLOYEE_TESTIMONIAL,
  JUDE_EMPLOYEE_TESTIMONIAL,
  JACOB_EMPLOYEE_TESTIMONIAL,
  SONALI_EMPLOYEE_TESTIMONIAL,
];
